export const createPayloadFromObject = (obj: any): string => {
  return JSON.stringify(obj, null, 2);
};

export const createTimestampFromEpochSeconds = (epochSeconds: number) => {
  return new Date(Math.floor(epochSeconds * 1000)).toLocaleString();
};

export const isNullOrUndefinedOrEmpty = (value: string | null | undefined): boolean => {
  return value === null || value === undefined || value.trim() === "";
};
